

const Separator = () => {
  return (
    <div
        style={{
            height: '8px',
            width: '100vw',
            background: 'rgba(18,30,18,.7)'
        }}
    >

    </div>
  )
}

export default Separator